import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.hiikoEnv || initialState;

export const selectHiikoEnv = createSelector([selectSlice], state => state);

export const selectEnvs = createSelector([selectHiikoEnv], state =>
  [...state.envs].sort((a, b) => a.name.localeCompare(b.name)),
);

export const selectIsCreateEnvLoading = createSelector(
  [selectHiikoEnv],
  state => state.createEnvLoading,
);
export const selectSelectedEnv = createSelector([selectHiikoEnv], state =>
  state.envs.find(env => env.id === state.selectedEnvId),
);

export const selectSelectedEnvId = createSelector(
  [selectHiikoEnv],
  state => state.selectedEnvId,
);

export const selectIsInitEnvsLoading = createSelector(
  [selectHiikoEnv],
  state => state.initLoading,
);
